module.exports = __webpack_public_path__ + "img/CO.8c5165f1.svg";